import * as pointColors from '../../../assets/styles/variables/colors.scss'

export default {
    iconFileColor:{
        color: '#78787D'
    },
    title:{
        color: pointColors.darkBlack500
    }
}